import moment from "moment-timezone";

export const useBasicDateTimeFormatter = (
  timestamp: number,
  options?: {
    includeTime?: boolean;
  }
) => {
  if (typeof timestamp !== "number") {
    return undefined;
  }

  const date = new Date(timestamp);

  // Handle invalid dates
  if (isNaN(date.getTime())) {
    return undefined;
  }

  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const day = date.getDate();
  const month = monthNames[date.getMonth()];
  const year = date.getFullYear();

  const absoluteTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const currentTime = moment.tz(absoluteTimezone);
  const timezone = currentTime.format("z");

  const includeTime =
    options?.includeTime !== undefined ? options.includeTime : true;

  if (!includeTime) {
    return `${month} ${day}, ${year}`;
  }

  return `${month} ${day}, ${year} at ${date.toLocaleTimeString([], {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  })} ${timezone}`;
};
